import script from "./applyExample.vue?vue&type=script&lang=ts&setup=true"
export * from "./applyExample.vue?vue&type=script&lang=ts&setup=true"

import "./applyExample.vue?vue&type=style&index=0&id=e725808a&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e725808a"]])

export default __exports__